import { ThreeDots } from '@/frontend/SVGs/ThreeDots';
import { forwardRef, LegacyRef, MouseEvent } from 'react';

type CustomToggleProps = {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
};

export function CustomToggle(instance: string, content?: any) {
  const toggleContent = content || <ThreeDots />;
  return (
    forwardRef(({ onClick }: CustomToggleProps, ref: LegacyRef<HTMLButtonElement>) => (
      <button
        aria-label={`${instance} dropdown menu`}
        type='button'
        className="btn no-border"
        style={{ paddingTop: '0px', paddingRight: '0px', paddingBottom: '0px', color: 'var(--neutral-600)' }}
        ref={ref}
        onClick={(event) => {
          event.preventDefault();
          onClick(event);
        }}
      >
        {toggleContent}
      </button>
    )));
  }
